import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCartoComponent } from './simple-icons-carto.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCartoComponent ],
    exports:      [ SimpleIconsCartoComponent ],
    bootstrap:    []
})
export class SimpleIconsCartoModule {}
